// Generated by CoffeeScript 2.3.2

import PerCategoryCardChooser from './PerCategoryCardChooser'
import MultiplePlayerChooser from './MultiplePlayerChooser'
import PlayerChooser from './PlayerChooser'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
;
var SuggestDialog,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } },
  indexOf = [].indexOf;

SuggestDialog = class SuggestDialog extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleChangeSuggesterId = this.handleChangeSuggesterId.bind(this);
    this.handleChangeCards = this.handleChangeCards.bind(this);
    this.handleChangeShowedIdsMaster = this.handleChangeShowedIdsMaster.bind(this);
    this.handleChangeShowedIdsClassic = this.handleChangeShowedIdsClassic.bind(this);
    this.handleChangeDidNotShowIdsClassic = this.handleChangeDidNotShowIdsClassic.bind(this);
    this.handleDoneMaster = this.handleDoneMaster.bind(this);
    this.handleDoneClassic = this.handleDoneClassic.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      suggesterId: null,
      cardIds: {},
      showedIds: [],
      didNotShowIds: []
    };
    return;
  }

  close() {
    this.setState({
      suggesterId: null,
      cardIds: {},
      showedIds: [],
      didNotShowIds: []
    });
    this.props.onClose();
  }

  stateIsOkMaster() {
    var cardCount, key;
    cardCount = ((function() {
      var results;
      results = [];
      for (key in this.state.cardIds) {
        results.push(key);
      }
      return results;
    }).call(this)).length;
    return (this.state.suggesterId != null) && cardCount === 3 && this.state.showedIds.length <= 3;
  }

  stateIsOkClassic() {
    var cardCount, key;
    cardCount = ((function() {
      var results;
      results = [];
      for (key in this.state.cardIds) {
        results.push(key);
      }
      return results;
    }).call(this)).length;
    return (this.state.suggesterId != null) && cardCount === 3;
  }

  stateIsOk() {
    if (this.props.configuration.rulesId === "master") {
      return this.stateIsOkMaster();
    } else {
      return this.stateIsOkClassic();
    }
  }

  handleClose() {
    boundMethodCheck(this, SuggestDialog);
    this.close();
  }

  handleChangeSuggesterId(playerId) {
    boundMethodCheck(this, SuggestDialog);
    this.setState({
      suggesterId: playerId
    });
  }

  handleChangeCards(typeId, cardId) {
    boundMethodCheck(this, SuggestDialog);
    this.setState(function(state, props) {
      var newCardIds;
      newCardIds = Object.assign({}, state.cardIds);
      newCardIds[typeId] = cardId;
      return {
        cardIds: newCardIds
      };
    });
  }

  handleChangeShowedIdsMaster(playerId, selected) {
    boundMethodCheck(this, SuggestDialog);
    if (selected) {
      this.setState(function(state, props) {
        if (indexOf.call(state.showedIds, playerId) < 0) {
          return {
            showedIds: state.showedIds.concat([playerId])
          };
        } else {
          return null;
        }
      });
    } else {
      this.setState(function(state, props) {
        var id;
        if (indexOf.call(state.showedIds, playerId) >= 0) {
          return {
            showedIds: (function() {
              var i, len, ref, results;
              ref = state.showedIds;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                id = ref[i];
                if (id !== playerId) {
                  results.push(id);
                }
              }
              return results;
            })()
          };
        } else {
          return null;
        }
      });
    }
  }

  handleChangeShowedIdsClassic(playerId) {
    boundMethodCheck(this, SuggestDialog);
    this.setState({
      showedIds: [playerId]
    });
  }

  handleChangeDidNotShowIdsClassic(playerId, selected) {
    boundMethodCheck(this, SuggestDialog);
    if (selected) {
      this.setState(function(state, props) {
        if (indexOf.call(state.didNotShowIds, playerId) < 0) {
          return {
            didNotShowIds: state.didNotShowIds.concat([playerId])
          };
        } else {
          return null;
        }
      });
    } else {
      this.setState(function(state, props) {
        var id;
        if (indexOf.call(state.didNotShowIds, playerId) >= 0) {
          return {
            didNotShowIds: (function() {
              var i, len, ref, results;
              ref = state.didNotShowIds;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                id = ref[i];
                if (id !== playerId) {
                  results.push(id);
                }
              }
              return results;
            })()
          };
        } else {
          return null;
        }
      });
    }
  }

  handleDoneMaster() {
    var cardId, cardIds, typeId;
    boundMethodCheck(this, SuggestDialog);
    if (!this.stateIsOkMaster()) {
      this.props.app.showConfirmDialog("Error", "You must select a suggester, 3 cards, and up to 3 players who showed cards.");
      return;
    }
    cardIds = (function() {
      var ref, results;
      ref = this.state.cardIds;
      results = [];
      for (typeId in ref) {
        cardId = ref[typeId];
        results.push(cardId);
      }
      return results;
    }).call(this);
    if (this.state.showedIds.length === 0) {
      this.props.app.showConfirmDialog("Please confirm", "Are you sure that nobody showed any cards?", () => {
        this.props.app.recordSuggestion(this.state.suggesterId, cardIds, this.state.showedIds);
        return this.close();
      }, function() {
        return {};
      });
      return;
    }
    this.props.app.recordSuggestion(this.state.suggesterId, cardIds, this.state.showedIds);
    this.close();
  }

  handleDoneClassic() {
    var cardId, cardIds, typeId;
    boundMethodCheck(this, SuggestDialog);
    if (!this.stateIsOkClassic()) {
      this.props.app.showConfirmDialog("Error", "You must select a suggester, 3 cards, and up to 3 players who showed cards.");
      return;
    }
    cardIds = (function() {
      var ref, results;
      ref = this.state.cardIds;
      results = [];
      for (typeId in ref) {
        cardId = ref[typeId];
        results.push(cardId);
      }
      return results;
    }).call(this);
    if (this.state.showedIds[0] == null) {
      this.props.app.showConfirmDialog("Please confirm", "Are you sure that nobody showed a card?", () => {
        this.props.app.recordSuggestion(this.state.suggesterId, cardIds, []);
        return this.close();
      }, function() {
        return {};
      });
      return;
    }
    this.props.app.recordSuggestion(this.state.suggesterId, cardIds, this.state.didNotShowIds.concat(this.state.showedIds));
    this.close();
  }

  handleDone() {
    boundMethodCheck(this, SuggestDialog);
    if (this.props.configuration.rulesId === "master") {
      this.handleDoneMaster();
    } else {
      this.handleDoneClassic();
    }
  }

  handleCancel() {
    boundMethodCheck(this, SuggestDialog);
    this.close();
  }

  render() {
    var configuration, open, players;
    ({open, players, configuration} = this.props);
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={this.handleClose}>
      <DialogTitle id="form-dialog-title">Record A Suggestion</DialogTitle>
      <DialogContent>
        <Typography variant="h4"> Who made the suggestion? </Typography>
        <PlayerChooser value={this.state.suggesterId} players={players} onChange={this.handleChangeSuggesterId} />
        <Divider />
        <Typography variant="h4"> What cards were suggested? </Typography>
        <PerCategoryCardChooser value={this.state.cardIds} cards={configuration.cards} types={configuration.types} onChange={this.handleChangeCards} />
        <Divider />
        {(configuration.rulesId === "master" ? <div>
              <Typography variant="h4"> Who showed a card? </Typography>
              <MultiplePlayerChooser value={this.state.showedIds} players={players} excluded={this.state.suggesterId !== null ? [this.state.suggesterId] : []} onChange={this.handleChangeShowedIdsMaster} />
            </div> : <div>
              <Typography variant="h4"> Who did not have a card? </Typography>
              <MultiplePlayerChooser value={this.state.didNotShowIds} players={players} excluded={(this.state.suggesterId !== null ? this.state.showedIds.concat([this.state.suggesterId]) : [])} onChange={this.handleChangeDidNotShowIdsClassic} />
              <Typography variant="h4"> Who showed a card? </Typography>
              <PlayerChooser value={this.state.showedIds[0]} players={players} excluded={(this.state.suggesterId !== null ? this.state.didNotShowIds.concat([this.state.suggesterId]) : [])} onChange={this.handleChangeShowedIdsClassic} />
            </div>)}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.handleCancel}> Cancel </Button>
        <Button disabled={!this.stateIsOk()} variant="contained" color="primary" onClick={this.handleDone}>
          Done
        </Button>
      </DialogActions>
    </Dialog>;
  }

};

export default SuggestDialog;
